import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown } from 'lucide-react';
import lg from "./logo.png";

export default function Navbar({ isLoggedIn, onLogout }) {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("is_guest");
        if (onLogout) onLogout();
        navigate("/login");
        setIsMenuOpen(false);
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    // Dropdown menüyü açmak için (hover ile)
    const openHoverDropdown = (menu) => {
        setOpenDropdown(menu);
    };

    // Dropdown menüyü kapatmak için (hover ile)
    const closeHoverDropdown = () => {
        setOpenDropdown(null);
    };

    return (
        <nav className="fixed top-0 left-0 w-full z-50 bg-gray-900/80 backdrop-blur-sm shadow-lg border-b border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center space-x-2">
                        <Link to="/" onClick={closeMenu} className="flex items-center">
                            {/* lg'nin dosya yolundan yüklendiği varsayılmıştır */}
                            <img src={lg} alt="Mekânname Logo" className="h-12 w-auto hover:scale-110 transition-transform" />
                            <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 ml-2">
                                Mekânname
                            </h1>
                        </Link>
                    </div>

                    <div className="hidden lg:flex items-center space-x-8">
                        <Link to="/AI" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300 font-medium lg:text-base flex items-center space-x-2">Mekânname AI</Link>
                        <Link to="/pricing" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300 font-medium lg:text-base flex items-center space-x-2">Fiyatlandırma</Link>
                        <Link to="/mekan" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300 font-medium lg:text-base flex items-center space-x-2">Keşfet</Link>
                        <div 
                            className="relative" 
                            onMouseEnter={() => openHoverDropdown('uygulamalar')} 
                            onMouseLeave={closeHoverDropdown}
                        >
                            <button className="text-gray-300 hover:text-indigo-400 transition-colors duration-300 font-medium lg:text-base flex items-center space-x-2">
                                Diğer Uygulamalar <ChevronDown size={16} className={`ml-1 transition-transform ${openDropdown === 'uygulamalar' ? 'rotate-180' : ''}`} />
                            </button>
                            {openDropdown === 'uygulamalar' && (
                                <div className="absolute top-full left-0 bg-gray-800 rounded-lg shadow-lg p-2 space-y-2 text-gray-300 min-w-[150px] z-20">
                                    <Link to="/virtual-tour" className="block px-3 py-1 hover:bg-gray-700 rounded">Sanal Tur</Link>
                                    <Link to="/route" className="block px-3 py-1 hover:bg-gray-700 rounded">Rotalar</Link>
                                    <Link to="/quiz" className="block px-3 py-1 hover:bg-gray-700 rounded">Mekânname Quiz</Link>
                                </div>
                            )}
                        </div>

                        {/* Hakkımızda Dropdown (Hover ile Açılan) */}
                        <div 
                            className="relative" 
                            onMouseEnter={() => openHoverDropdown('hakkimizda')} 
                            onMouseLeave={closeHoverDropdown}
                        >
                            <button className="text-gray-300 hover:text-indigo-400 transition-colors duration-300 font-medium lg:text-base flex items-center space-x-2">
                                Destek <ChevronDown size={16} className={`ml-1 transition-transform ${openDropdown === 'hakkimizda' ? 'rotate-180' : ''}`} />
                            </button>
                            {openDropdown === 'hakkimizda' && (
                                <div className="absolute top-full left-0 bg-gray-800 rounded-lg shadow-lg p-2 space-y-2 text-gray-300 min-w-[200px] z-20">
                                    <Link to="/contact" className="block px-3 py-1 hover:bg-gray-700 rounded">İletişim</Link>
                                    <Link to="/about" className="block px-3 py-1 hover:bg-gray-700 rounded">Hakkımızda</Link>
                                    <Link to="/blog" className="block px-3 py-1 hover:bg-gray-700 rounded">Blog</Link>
                                    <Link to="/sss" className="block px-3 py-1 hover:bg-gray-700 rounded">S.S.S.</Link>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="hidden lg:flex items-center space-x-4">
                        {isLoggedIn ? (
                            <>
                                <Link to="/profile" className="px-4 py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-full text-sm font-medium">Profil</Link>
                                <button onClick={handleLogout} className="px-4 py-2 text-gray-300 border border-gray-700 hover:text-white hover:border-indigo-600 rounded-full text-sm font-medium">Çıkış Yap</button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" onClick={closeMenu} className="block px-4 py-2 text-white bg-indigo-600 hover:bg-transparent border border-indigo-600 rounded-full text-center">Giriş Yap</Link>
                                <Link to="/register" className="px-4 py-2 text-white bg-transparent border-indigo-600 border hover:bg-indigo-600 rounded-full text-sm font-medium">Kayıt Ol</Link>
                            </>
                        )}
                    </div>

                    <div className="-mr-2 flex lg:hidden">
                        <button onClick={toggleMenu} className="p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700">
                            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobil Menü */}
            {isMenuOpen && (
                <div className="text-gray-300 lg:hidden bg-gray-900/90 backdrop-blur-sm shadow-xl">
                    <Link to="/AI" onClick={closeMenu} className="block px-4 py-2 text-gray-300 hover:bg-gray-700">Mekânname AI</Link>
                    <Link to="/pricing" onClick={closeMenu} className="block px-4 py-2 text-gray-300 hover:bg-gray-700">Fiyatlandırma</Link>
                    <Link to="/mekan" onClick={closeMenu} className="block px-4 py-2 text-gray-300 hover:bg-gray-700">Keşfet</Link>
                    <div className="px-4 py-2">
                        <p className="text-gray-400">Diğer Uygulamalar</p>
                        <Link to="/virtual-tour" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">Sanal Tur</Link>
                        <Link to="/route" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">Rotalar</Link>
                        <Link to="/quiz" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">Mekânname Quiz</Link>
                    </div>
                    <div className="px-4 py-2">
                        <p className="text-gray-400">Destek</p>
                        <Link to="/contact" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">İletişim</Link>
                        <Link to="/about" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">Hakkımızda</Link>
                        <Link to="/blog" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">Blog</Link>
                        <Link to="/sss" onClick={closeMenu} className="block px-4 py-1 hover:bg-gray-700">S.S.S.</Link>
                    </div>
                    <div className="px-4 py-2 border-t border-gray-700">
                        {isLoggedIn ? (
                            <>
                                <Link to="/profile" onClick={closeMenu} className="block px-4 py-2 text-white bg-indigo-600 rounded-full text-center">Profil</Link>
                                <button onClick={handleLogout} className="w-full mt-2 px-4 py-2 text-gray-300 border border-gray-700 rounded-full">Çıkış Yap</button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" onClick={closeMenu} className="block px-4 py-2 text-white bg-indigo-600 rounded-full text-center">Giriş Yap</Link>
                                <Link to="/register" onClick={closeMenu} className="block px-4 py-2 text-gray-300 border border-gray-700 rounded-full mt-2 text-center">Kayıt Ol</Link>
                            </>
                        )}
                    </div>
                </div>
            )}
        </nav>
    );
}
